import { Injectable } from '@angular/core';
import { AppHttpClient } from './app-http-client.service';
import { map } from 'rxjs';
import { ApproachProfileService } from './approach-profile.service';

@Injectable({
  providedIn: 'root'
})
export class AttestationService {

  artifactKeys:any[] = [];
  approaches: string[] = [];
  artifactKeysByApproch: any = {};
  constructor(
    public http : AppHttpClient,
    public profileService: ApproachProfileService,
  ) { }

  getContents(){
    return this.http.get('attestations').pipe(
      map((res:any) => {
        res.approaches.map((i:any) =>{
          this.artifactKeysByApproch[i.approach] = i.contents.map((j:any) => j.artifactKey);
        });
        return res.approaches.reduce((acc:any[], item:any) => acc.concat(item.contents) , []);
      })
    );
  }

  setArtifactKeys(){
    this.http.get('attestations?keys=true').subscribe((res:any) => {
      this.artifactKeys = res.artifactKeys;
    });
    this.profileService.getProfiles({}).subscribe((res:any) => {
       this.approaches = res.map((i:any) =>i.ApproachName);
    });
  }

  createContent(payload: any){
    return this.http.post('attestations', payload);
  }

  updateContent(payload: any){
    return this.http.put('attestations', payload);
  }
}
